var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"controlInstanceList"},[_c('table-list',{ref:"tableList",attrs:{"extr":_vm.params,"code":_vm.params.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }